import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSliderModule } from 'ng-zorro-antd/slider';

@Component({
  selector: 'ui-slider-input-control',
  imports: [FormsModule, NzSliderModule, NzInputNumberModule],
  templateUrl: './slider-input-control.html',
  styleUrl: './slider-input-control.scss',
})
export class UiSliderInputControlComponent {
  readonly value = input.required<number>();
  readonly min = input(0);
  readonly max = input(100);
  readonly step = input(1);
  readonly unit = input<string | null>(null);
  readonly showInput = input(true);

  readonly valueChange = output<number>();
  readonly sliderUsed = output<void>();
  readonly committed = output<void>();

  onSliderChange(value: number): void {
    this.sliderUsed.emit();
    this.emitClamped(value);
  }

  onInputChange(value: number | null): void {
    if (value === null) return;
    this.emitClamped(value);
    this.committed.emit();
  }

  onSliderCommit(): void {
    this.committed.emit();
  }

  private emitClamped(value: number): void {
    const clamped = Math.max(this.min(), Math.min(this.max(), Math.round(value)));
    this.valueChange.emit(clamped);
  }
}
